import { render, staticRenderFns } from "./downModels.vue?vue&type=template&id=073c53ce&scoped=true&"
import script from "./downModels.vue?vue&type=script&lang=ts&"
export * from "./downModels.vue?vue&type=script&lang=ts&"
import style0 from "./downModels.vue?vue&type=style&index=0&id=073c53ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c53ce",
  null
  
)

export default component.exports